import { Button } from '@/frontend/components/ui/button'
import { JSX } from 'react'
import { ArrowRight } from '@/frontend/components/ui/icons'
import { CTAType, SingleCTAType } from '@/payload-custom-types'

export const CTAArray = ({ ctaArray }: { ctaArray: CTAType['ctaArray'] }) => {
  if (!ctaArray) return null
  const arr = ctaArray
  if (!arr?.length) return null

  return arr.map((cta, index) => {
    if (!cta) return null
    const ctaElement = cta.cta
    if (!ctaElement?.linkTypeSelect) return null

    const linkText = ctaElement?.text ? ctaElement.text : '{LINKTEXT HINZUFÜGEN}'

    const LinkElements: { [key: string]: JSX.Element } = {
      external: <LinkExternal key={index} cta={ctaElement} linkText={linkText} />,
      internal: <LinkInternal key={index} cta={ctaElement} linkText={linkText} />,
      anchor: <LinkAnchor key={index} cta={ctaElement} linkText={linkText} />,
    }

    return LinkElements[ctaElement.linkTypeSelect]
  })
}
CTAArray.displayName = 'CTAArray'

export const LinkExternal = ({
  cta,
  linkText,
}: {
  cta: SingleCTAType['cta']
  linkText: string
}) => {
  if (!cta) return null

  const href = cta.linkExt ? cta.linkExt : '/'
  return (
    <Button
      href={href}
      variant={cta.layout}
      icon={cta.showIcon ? 'default' : 'none'}
      buttontext={linkText}
      target={cta.openNewTab ? '_blank' : '_self'}
      rel="noreferrer"
    >
      <span>{linkText}</span>
      {cta.showIcon && <ArrowRight />}
    </Button>
  )
}
LinkExternal.displayName = 'LinkExternal'

export const LinkInternal = ({
  cta,
  linkText,
}: {
  cta: SingleCTAType['cta']
  linkText: string
}) => {
  if (!cta) return null

  let linkslug = '/'
  if (typeof cta.linkInt === 'object' && cta.linkInt?.slug) {
    if (cta.linkInt?.slug === 'home') {
      linkslug = '/'
    } else {
      linkslug = `/${cta.linkInt?.slug}`
    }
  }

  return (
    <Button
      href={`${linkslug}`}
      variant={cta.layout}
      icon={cta.showIcon ? 'default' : 'none'}
      buttontext={linkText}
      target={cta.openNewTab ? '_blank' : '_self'}
      rel="noreferrer"
    >
      <span>{linkText}</span>
      {cta.showIcon && <ArrowRight />}
    </Button>
  )
}
LinkInternal.displayName = 'LinkInternal'

export const LinkAnchor = ({ cta, linkText }: { cta: SingleCTAType['cta']; linkText: string }) => {
  if (!cta) return null

  const checkForAnchorSymbol = (anchorLink: string | null | undefined) => {
    if (anchorLink?.includes('#')) {
      return anchorLink
    }

    return `#${anchorLink}`
  }

  return (
    <Button
      href={checkForAnchorSymbol(cta.linkAnchor)}
      variant={cta.layout}
      icon={cta.showIcon ? 'default' : 'none'}
      buttontext={linkText}
      target={cta.openNewTab ? '_blank' : '_self'}
      rel="noreferrer"
    >
      <span>{linkText}</span>
      {cta.showIcon && <ArrowRight />}
    </Button>
  )
}
LinkAnchor.displayName = 'LinkAnchor'
